import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import React, { useState, } from "react";
import "./style.css";
import shirt from "./../../assets/images/white-shirt.png";
import DrawerAppBar from "../Header/drawer";
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from "react-share";
import { Download } from "@mui/icons-material";


export default function Generate() {
  let colors = [
    "red",
    "orange",
    "yellow",
    "green",
    "blue",
    "purple",
    "pink",
    "brown",
    "gray",
    "black",
    "white",
    "teal",
  ];
  let shirtSizes = [
    "small",
    "medium",
    "large",
    "X-large",
    "2X-large",
    "3X-large",
  ];

  const [color, setColor] = useState("");
  const [description, setDescription] = useState("");
  const [img, setImg] = useState("");
  const [dimensions,setDimensions] = useState({width:512,height:512})
  const [loading, setLoading] = useState(false);

  async function generateDesign() {
    setLoading(true);
    const engineId = "stable-diffusion-v1-5";
    const apiHost = process.env.API_HOST ?? "https://api.stability.ai";
    const apiKey = process.env.REACT_APP_STABILITY_API_KEY;

    if (!apiKey) throw new Error("Missing Stability API key.");

    const response = await fetch(
      `${apiHost}/v1/generation/${engineId}/text-to-image`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${apiKey}`,
        },
        body: JSON.stringify({
          text_prompts: [
            {
              text: `t-shirt with design with ${description}, color ${color}, highly detailed work,ready to print, high-contrast, stylized`,
            },
          ],
          cfg_scale: 7,
          height: dimensions.height,
          width: dimensions.width,
          samples: 1,
          steps: 30,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`Non-200 response: ${await response.text()}`);
    }
    const responseJSON = await response.json();

    
    setLoading(false);
    
    setImg(responseJSON.artifacts[0]["base64"]);
  }

  function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }
  
  return (
    <Box bgcolor={'#5a589c'}>
      <DrawerAppBar />

      <Box className="wrapper" sx={{marginTop:{md:"0px",xs:"80px"}}}>
        <Paper
          elevation={10}
          className="box"
          // sx={{ marginX: { md: "40px !important", xs: "10px" } }}
        >
          <Grid container>
            <Grid item xs={12} md={7} lg={8}>
              <Box component={'div'} >
                {img !== "" ? (
                 
                  <Box position={'relative'}  component={'div'} className="imgActionsArea" height={'100%'}>
                  <Box position={'absolute'}top={'10px'} right={"1%"} bgcolor={'white.main'} display={'none'} component={'div'} className="imgDownlaodAction">
                    <Button  startIcon={  <Download />} color="error" onClick={() => {
                        let a = document.createElement("a"); 
                        a.href = "data:image/png;base64," + img; //Image Base64 Goes here
                        a.download = "t-shirt.png"; 
                        a.click(); 
                    }}
                    sx={{textTransform:"capitalize"}}
                    >
                    Download
                    </Button>
                  </Box>
                  <img
                    src={`data:image/png;base64,${img}`}
                    alt=""
                    width={'100%'}
                    height={'100%'}
                    className="image"
                  />
                 </Box>
                ) : (
                 <Box position={'relative'} >
                 
                   <img src={shirt} width={'512px'} height={'512px'} alt="" className="image" />
                 </Box>
                )}
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={5}
              lg={4}
              className="fields"
              sx={{ paddingX: { md: "70px", xs: "10px" } }}
            >
              <Box display={'flex'}  style={{ paddingTop: "50px" }} >
              <Box >
                <TextField
                disabled
                  fullWidth
                  variant="outlined"
                  id="filled-basic"
                  label="Height"
                  value={dimensions.height}
                  onChange={(e) => setDimensions({...dimensions,height:e.target.value})}
                />
              </Box>
              <Box>
                <TextField
                  fullWidth
                disabled
                variant="outlined"
                  id="filled-basic"
                  label="Width"
                  value={dimensions.width}
                  onChange={(e) => setDimensions({...dimensions,width:e.target.value})}
                />
              </Box>
              </Box>
              <Box style={{ paddingTop: "50px" }}>
                <FormControl variant="filled" fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Color
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select Color"
                    variant="outlined"
                  
                    sx={{ marignX: "10px" }}
                    value={color}
                    onChange={(e) => setColor(e.target.value)}
                  >
                    {colors.map((s) => (
                      <MenuItem value={s}>{s}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
           
              <Box style={{ paddingTop: "50px" }}>
                <TextField
                  multiline
                  rows={5}
                  fullWidth
                  variant="outlined"
                  id="filled-basic"
                  label="Description"
                  placeholder="t-shirt with red heart"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Box>
              <Box
                style={{
                  paddingTop: "50px",
                  textAlign: "center",
                }}
              >
                <Button
                  disabled={loading}
                  variant="contained"
                  size="large"
                  onClick={generateDesign}
                >
                  Generate
                </Button>
              </Box>
              <Box
                style={{
                  paddingTop: "10px",
                  textAlign: "center",
                }}
              >
                <Button
                  disabled={loading}
                  onClick={() => {
                    setDescription(`t-shirt with design with random design,  color ${color}, highly detailed work,ready to print, high-contrast, stylized`)
                    setColor(colors[ Math.floor(Math.random() * colors.length)])
                    generateDesign()
                  }}
                >
                  Generate Random
                </Button>
              </Box>
              { img !== "" &&   <Box  style={{
                  paddingTop: "10px",
                  textAlign: "center",
                }}>
                
                 <FacebookShareButton  url={URL.createObjectURL(b64toBlob(img))} style={{margin:"0 5px"}}>
                    <FacebookIcon size={'30px'} />
                  </FacebookShareButton>
                  <TwitterShareButton url={URL.createObjectURL(b64toBlob(img))} style={{margin:"0 5px"}}>
                    <TwitterIcon  size={'30px'}/>
                  </TwitterShareButton>
                  <WhatsappShareButton url={URL.createObjectURL(b64toBlob(img))} style={{margin:"0 5px"}}>
                    <WhatsappIcon size={'30px'}/>
                  </WhatsappShareButton>
              </Box>}
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Box>
  );
}
